import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  Show,
  SimpleShowLayout,
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  Edit,
  required,
  email,
} from 'react-admin';
import { createEmptyStateComponent } from '../../components/createEmptyStateComponent';

const UserEmptyState = createEmptyStateComponent('users');

export const UserList = () => (
  <List title="Users" empty={<UserEmptyState />}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="name" />
      <EmailField source="email" />
      <BooleanField source="emailVerified" />
      <TextField source="roles" />
    </Datagrid>
  </List>
);

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <EmailField source="email" />
      <BooleanField source="emailVerified" />
      <TextField source="roles" />
    </SimpleShowLayout>
  </Show>
);

export const UserCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <TextInput source="email" validate={[required(), email()]} />
      <TextInput source="password" type="password" validate={[required()]} />
      <BooleanInput source="emailVerified" />
    </SimpleForm>
  </Create>
);

export const UserEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <TextInput source="email" validate={[required(), email()]} />
      <BooleanInput source="emailVerified" />
    </SimpleForm>
  </Edit>
);
